package com.evoapps.evoshift.domain.usecase.auth

import com.evoapps.evoshift.domain.repository.UserRepository

class CompleteSetupUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(userId: String): Result<Unit> {
        return try {
            val userResult = userRepository.getUserProfile(userId)
            val user = userResult.getOrThrow()
            userRepository.updateUserProfile(user.copy(isSetupComplete = true))
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
